/**
 * Decodes the `roles` claim from a JWT access token payload without verifying its signature.
 * Used only as a fallback when `roles` are not already present in the ID token claims.
 * Never throws: any decode/parse failure or a non-array `roles` claim resolves to `[]`.
 */
export function readRolesFromAccessToken(accessToken: string): string[] {
    const payload = decodePayload(accessToken);

    if (!payload || typeof payload !== 'object') {
        return [];
    }

    const roles = (payload as Record<string, unknown>)['roles'];

    if (!Array.isArray(roles)) {
        return [];
    }

    return roles.filter((role): role is string => typeof role === 'string');
}

function decodePayload(accessToken: string): unknown {
    try {
        const segments = accessToken.split('.');

        if (segments.length < 2) {
            return null;
        }

        const base64 = segments[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const json = atob(padded);

        return JSON.parse(json);
    } catch {
        return null;
    }
}
